export const companyImgs = {
  banner: 'https://cdnw2.acmcoder.com/files/20200709/2020081001.jpg'
}
export const companyBdData = [
  {
    src: 'http://meicai.zhaopin.com/',
    img: 'https://cdnw2.acmcoder.com/files/20200904/20200911093541.jpg'
  },
  {
    src: 'https://jinshuju.net/f/YjRll2',
    img: 'https://cdnw2.acmcoder.com/files/202008/202009021622.png'
  },
  {
    src: 'https://clubz.cloudsation.com/ebay/index',
    img: 'https://cdnw2.acmcoder.com/files/202008/20200916161410.jpg'
  },
  {
    src: 'https://mp.weixin.qq.com/s/xHHkZ09uCe8xvvMCCtztgw',
    img: 'https://cdnw2.acmcoder.com/files/202008/20200916161420.jpg'
  },
  {
    src: 'http://campus.51job.com/zkxt2021/',
    img: 'https://cdnw2.acmcoder.com/files/202009/20200928165229.png'
  },
  {
    src: 'http://campus.51job.com/vmware2021/',
    img: 'https://cdnw2.acmcoder.com/files/202009/20200928171150.jpg'
  }
]
export const topicTypeList = [
  {
    icon: 'iconfont iconsuanfa',
    title: '基本算法',
    num: '2323'
  },
  { icon: 'iconfont iconpeople-network', title: '数据结构', num: '4342' },
  { icon: 'iconfont iconzhexiantu', title: '动态规划', num: '13423' },
  { icon: 'iconfont iconxianghuzuoyong', title: '字符串', num: '4523' },
  { icon: 'iconfont iconsousuo', title: '搜索', num: '234' },
  { icon: 'iconfont icontu', title: '模拟', num: '2342' },
  { icon: 'iconfont iconshuxue', title: '数论', num: '234' },
  { icon: 'iconfont iconlifangti', title: '排序', num: '454435' }
]
export const companyList = [
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  },
  {
    comp_logo:
      'http://image.acmcoder.com/v1/acmimg/7864517416072246.png?authorization=bce-auth-v1%2F02fe1db0eea94e8480054b43acd6124f%2F2017-08-30T05%3A41%3A30Z%2F-1%2F%2F2f62d36ebe8130d40c14df215583d9c2bfa6c4e1b2a8c0964dc28173f3928613',
    comp_name: '京东',
    num: 343
  }
]



// WEBPACK FOOTER //
// ./src/pages/practice/company/config.js